import { ChakraTheme, theme as chakraTheme } from '@chakra-ui/react'
import { ComponentStyleConfig } from '@chakra-ui/theme'
import { getColor } from '@chakra-ui/theme-tools'

const { baseStyle } = chakraTheme.components.Checkbox

const disabled = {
  borderColor: 'neutral.30',
  color: 'white.0',
  cursor: 'not-allowed',
}
const disabledStyle = {
  ...disabled,
  background: 'white.0',
}
const disabledCheckedStyle = {
  ...disabled,
  background: 'neutral.30',
}

const getBoxShadow = (theme: ChakraTheme) =>
  `0px 0px 0px 2px ${getColor(theme, 'white.0')}, 0px 0px 0px 4px ${getColor(
    theme,
    'deepPurple',
  )}`

export const Checkbox: ComponentStyleConfig = {
  baseStyle: props => ({
    control: {
      ...baseStyle(props).control,
      _checked: {
        _disabled: {
          ...disabledCheckedStyle,
          _active: disabledCheckedStyle,
        },
      },
      _disabled: {
        ...disabledStyle,
        _active: disabledStyle,
      },
      border: '2px solid',
      borderRadius: 0,
      color: 'white.0',
    },
    label: {
      ...baseStyle(props).label,
      _disabled: {
        color: 'neutral.50',
        cursor: 'not-allowed',
      },
      color: 'deepPurple',
      cursor: 'pointer',
    },
  }),
  defaultProps: {
    colorScheme: '',
    size: 'md',
    variant: 'gradient',
  },
  variants: {
    gradient: ({ theme }) => ({
      control: {
        _active: {
          background: 'neutral.20',
          borderColor: 'neutral.90',
        },
        _checked: {
          _active: {
            background: 'blue.60',
            borderColor: 'blue.60',
          },
          _focus: {
            backgroundOrigin: 'border-box',
            bgGradient: `linear(to-r, violet.50, blue.50)`,
            borderColor: 'transparent',
            boxShadow: getBoxShadow(theme),
          },
          _hover: {
            background: 'blue.50',
            borderColor: 'blue.50',
          },
          backgroundOrigin: 'border-box',
          bgGradient: `linear(to-r, violet.50, blue.50)`,
          borderColor: 'transparent',
        },
        _focus: {
          background: `neutral.30`,
          boxShadow: getBoxShadow(theme),
        },
        _hover: {
          background: 'neutral.10',
          borderColor: 'neutral.80',
        },
        borderColor: 'neutral.70',
      },
    }),
    solid: ({ colorScheme, theme }) => ({
      control: {
        _active: {
          background: colorScheme ? `${colorScheme}.20` : 'neutral.20',
          borderColor: colorScheme ? `${colorScheme}.90` : 'neutral.90',
        },
        _checked: {
          _active: {
            background: colorScheme ? `${colorScheme}.90` : 'deepPurple',
            borderColor: colorScheme ? `${colorScheme}.90` : 'deepPurple',
          },
          _focus: {
            background: colorScheme ? `${colorScheme}.90` : 'deepPurple',
            borderColor: colorScheme ? `${colorScheme}.90` : 'deepPurple',
            boxShadow: getBoxShadow(theme),
          },
          _hover: {
            background: colorScheme ? `${colorScheme}.80` : 'neutral.80',
            borderColor: colorScheme ? `${colorScheme}.80` : 'neutral.80',
          },
          background: colorScheme ? `${colorScheme}.90` : 'deepPurple',
          borderColor: colorScheme ? `${colorScheme}.90` : 'deepPurple',
        },
        _focus: {
          background: colorScheme ? `${colorScheme}.30` : 'neutral.30',
          borderColor: colorScheme ? `${colorScheme}.30` : 'neutral.30',
          boxShadow: getBoxShadow(theme),
        },
        _hover: {
          background: colorScheme ? `${colorScheme}.10` : 'neutral.10',
          borderColor: colorScheme ? `${colorScheme}.80` : 'neutral.80',
        },
        borderColor: 'neutral.70',
      },
    }),
  },
}
